import { render, staticRenderFns } from "./IconGallery.vue?vue&type=template&id=bbfe6e26&"
import script from "./IconGallery.vue?vue&type=script&lang=js&"
export * from "./IconGallery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports